const initialState = {
    showrooms: []
};

const showroomReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case "ADD_SHOWROOM":
            return {
                ...state,
                showrooms: payload,
            };
        default:
            return state;
    }
};

export default showroomReducer;
